module.exports = __webpack_public_path__ + "static/solution-server-df23dcb3ec0ff3d77980d6db001ce7d4.png";